import './InteractiveMapLayout.css';
import React from 'react';
import { canUseDOM } from '../../../utils';
var InteractiveMapLayout = function InteractiveMapLayout(_ref) {
  var leftBar = _ref.leftBar,
    rightBar = _ref.rightBar,
    loading = _ref.loading,
    params = _ref.params,
    rtl = _ref.rtl,
    stylesVariables = _ref.stylesVariables,
    _ref$allowSearch = _ref.allowSearch,
    allowSearch = _ref$allowSearch === void 0 ? false : _ref$allowSearch,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView;
  React.useEffect(function () {
    var breadcrumb = canUseDOM ? document.querySelector('.breadcrumb-nav') : null;
    if (breadcrumb) {
      breadcrumb.classList.add('with-interactive-map');
      return function () {
        breadcrumb.classList.remove('with-interactive-map');
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container m114-im ".concat(loading ? 'loader-shown' : '', " ").concat(withMapModalView ? 'modal-view' : ''),
    style: stylesVariables
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "loader"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "m114-im__left-bar ".concat(allowSearch ? 'search-mode' : '', " ")
  }, leftBar, " "), /*#__PURE__*/React.createElement("div", {
    className: "m114-im__right-bar"
  }, rightBar))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1g79zid";
var ltrStyles = "lxyxjgy";
var rtlStyles = "r17jeof0";
export default InteractiveMapLayout;